import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

const ModalOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999999;
`;

const ModalContent = styled.div`
	background-color: white;
	border-radius: 12px;
	padding: 32px;
	text-align: center;
	max-width: 400px;
	width: 90%;
	box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

const ModalIcon = styled.div`
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background-color: rgb(33 191 84);
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto 24px;
	
	&::after {
		content: '✓';
		color: white;
		font-size: 35px;
		font-weight: bold;
	}
`;

const ModalTitle = styled.h3`
	font-size: 18px;
	font-weight: 600;
	color: #111827;
	margin-bottom: 24px;
`;

const ModalText = styled.p`
	font-size: 16px;
	color: #374151;
	margin-bottom: 32px;
`;

const ButtonGroup = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
`;

const ModalButton = styled.button<{ variant: 'cancel' | 'confirm' }>`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 24px;
	border-radius: 8px;
	border: none;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	
	${props => props.variant === 'cancel' ? `
		background-color: #EF4444;
		color: white;
		
		&:hover {
			background-color: #EF4444;
		}
	` : `
		background-color: #17B26A;
		color: white;
		
		&:hover {
			background-color: #17B26A;
		}
	`}
`;

interface CancelConfirmModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export default function CancelConfirmModal({ isOpen, onClose, onConfirm }: CancelConfirmModalProps) {
	if (!isOpen) return null;

	const modalContent = (
		<ModalOverlay onClick={onClose}>
			<ModalContent onClick={(e) => e.stopPropagation()}>
				<ModalIcon />
				<ModalTitle>Bạn có chắc chắn hủy ?</ModalTitle>
				<ButtonGroup>
					<ModalButton variant="cancel" onClick={onClose}>
						✕ Đóng
					</ModalButton>
					<ModalButton variant="confirm" onClick={onConfirm}>
						✓ Đồng ý
					</ModalButton>
				</ButtonGroup>
			</ModalContent>
		</ModalOverlay>
	);

	return createPortal(modalContent, document.body);
}
